export interface Role {
  key: number;
  value: string;
  order: number;
}

export type ContractRole = {
  id: number;
  abbr: string;
  roleName: string;
  elevated: boolean;
};
